export default __webpack_public_path__ + "static/media/two-steps-verification-illustration.98d06477.svg";